import React from 'react';
import { motion } from 'framer-motion';
import { Music, CloudMoon, Target, LayoutGrid, Globe } from 'lucide-react';
import './FeaturesSection.css';

const featureList = [
  { icon: <Music />, title: "Relaxing Music Library", desc: "Curated calming tracks for stress relief, meditation, and peace." },
  { icon: <CloudMoon />, title: "Sleep Support Sessions", desc: "Sounds crafted to help you unwind faster and sleep better." },
  { icon: <Target />, title: "Focus Booster", desc: "Background audio that helps improve concentration." },
  { icon: <LayoutGrid />, title: "Simple User Experience", desc: "Clean, easy-to-use design for instant relaxation." },
  { icon: <Globe />, title: "Anytime Access", desc: "Use at home, at work, while traveling, or whenever stress appears." }
];

const FeaturesSection = () => {
  return (
    <section className="section-padding features-section">
      <div className="container">
        <div className="features-grid-layout">
          <motion.div 
            className="features-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">Premium Features</span>
            <h2>Designed for your <span className="text-primary">well-being.</span></h2>
            <p>
              Whether you need to boost your productivity during the day or wind down at night, Relax has you covered.
            </p>
          </motion.div>
          
          <div className="features-list">
            {featureList.map((item, index) => (
              <motion.div 
                className="feature-item" 
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="feature-item-icon">{item.icon}</div>
                <div className="feature-item-content">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
